<div class="text-center" *ngIf="data == null || data.length == 0">
    <label class="pt-4"><h4 class="text-center">No Data</h4></label><br>
    <span *ngIf="message">{{message}}</span>
</div>